/**
 * Monaco 기반 편집 가능한 HTML 뷰.
 * 편집본은 훅의 `edited[stage]` 로 저장되어 다음 단계 입력으로 사용된다.
 */

import Editor from '@monaco-editor/react'
import type { StageName } from './stages'

interface Props {
  stage: StageName
  value: string
  onChange: (html: string) => void
  readOnly?: boolean
}

export function StageHtmlEditor({ value, onChange, readOnly }: Props) {
  return (
    <div style={{ height: '100%', minHeight: 0 }}>
      <Editor
        height="100%"
        defaultLanguage="html"
        language="html"
        value={value}
        onChange={(v) => onChange(v ?? '')}
        theme="vs-dark"
        options={{
          minimap: { enabled: false },
          fontSize: 13,
          wordWrap: 'on',
          tabSize: 2,
          readOnly,
        }}
      />
    </div>
  )
}
